import { createApp } from 'vue';
import WoffToWoff2Converter from '@/Components/WoffToWoff2Converter.vue';
import '@styles/app.css';

createApp(WoffToWoff2Converter).mount('#woff-to-woff2-converter');
